<template>
  <el-dialog
    title="完成步骤"
    :visible.sync="visible"
    width="485px"
    @close="$emit('update:show', false)"
    @open="handleOpen"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      size="small"
      label-width="130px"
    >
      <el-form-item label="步骤名称">
        <div class="text-gray">{{ model.step.name }}</div>
      </el-form-item>
      <el-form-item
        label="执行结果"
        prop="has_not_done"
        v-if="model.step.return_step != 0"
      >
        <el-radio-group v-model="model.has_not_done">
          <el-radio :label="false" border>完成</el-radio>
          <el-radio :label="true" border>未完成</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="评价短信接收对象"
        v-if="model.step.send_comment_msg != 0 && model.msg_send_type"
      >
        <el-select
          v-model="model.msg_send_type"
          @change="model.customer_contact_id = null"
        >
          <el-option label="最终客户" :value="1"></el-option>
          <el-option label="中间商" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="评价短信接收人"
        prop="customer_contact_id"
        v-if="model.step.send_comment_msg != 0"
      >
        <CustomerContactSelect
          v-if="model.msg_send_type == 2"
          :add="true"
          :customerID="model.dealer_customer_id"
          :val="model.customer_contact_id"
          @change="model.customer_contact_id = $event"
        ></CustomerContactSelect>
        <CustomerContactSelect
          v-else
          :add="true"
          :customerID="model.customer_id"
          :val="model.customer_contact_id"
          @change="model.customer_contact_id = $event"
        ></CustomerContactSelect>
      </el-form-item>
      <el-form-item
        label="下个步骤"
        prop="next_step_id"
        v-if="
          (model.step.return_step == 0 || model.has_not_done == false) &&
          model.is_last_step
        "
      >
        <el-select v-model="model.next_step_id" placeholder="请选择下个步骤">
          <el-option
            v-for="step in steps"
            :label="`${step.name}${step.desc ? '（' + step.desc + '）' : ''}`"
            :value="step.id"
            :key="step.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          placeholder="选填"
          :rows="3"
          v-model="model.remark"
        ></el-input>
        <div
          class="text-danger font-12"
          v-if="model.step.total_day > model.step.wait_time"
        >
          该步骤已超时，请填写超时原因！
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <span
        style="margin-right: 10px; font-size: 12px"
        v-if="model.step.send_comment_msg != 0"
      >
        <el-button type="text" size="mini" @click="issueVisible = true"
          >上传/补充现场设备信息</el-button
        >
      </span>
      <el-button @click="visible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submitForm" size="small"
        >确 定</el-button
      >
    </div>
    <CustomerIssue
      v-if="model.step.send_comment_msg != 0"
      :show.sync="issueVisible"
      :customerID="model.customer_id"
      :orderID="model.id"
      :customerName="model.customer_name"
    ></CustomerIssue>
  </el-dialog>
</template>

<script>
import { serviceQuestFlowStepList } from '@/service/getData'
import { serviceQuestDone } from '@/service/getDataV2'

import CustomerContactSelect from '@/components/select/customer_contact_select'
import CustomerIssue from './customer_issues'

export default {
  components: {
    CustomerContactSelect,
    CustomerIssue,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      issueVisible: false,
      visible: this.show,
      rules: {
        next_step_id: [
          { required: true, message: '请选择下个流程步骤', trigger: 'change' },
        ],
        has_not_done: [
          {
            required: true,
            message: '请选择当前步骤执行结果',
            trigger: 'change',
          },
        ],
        customer_contact_id: [
          {
            required: true,
            message: '请选择评价短信接收人',
            trigger: 'change',
          },
        ],
      },
      steps: [],
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.clone(this.model)
          delete data.customer_name
          delete data.step

          let res = await serviceQuestDone(data)
          if (res.code == 0) {
            this.$emit('updated', res.data)
            this.visible = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    async handleOpen() {
      if (this.model.is_last_step) {
        let res = await serviceQuestFlowStepList({
          father_id: this.model.step.step_id,
        })

        if (res.code == 0) {
          if (res.data.list.length == 0) {
            this.model.is_last_step = false
          } else {
            this.steps = res.data.list
          }
        }
      }
    },
  },
}
</script>